// LogoSplash.js
import React from 'react';
import './LogoSplash.css'; 


const LogoSplash = () => {
  return (
   <div className="logo-splash">
  <img src='/image/Logo.png' alt="Company Logo" className="logo" style={{ width: '400px', height: '400px' }} />
</div>
  );
};

export default LogoSplash;